<template>

    <component
        :field="field"
        :is="importInput(field.type)"
        ref="input"
    ></component>

</template>

<script>
export default {
    name : "FormFieldsGroup",
}
</script>

<script setup>

import { ref }                   from "vue";
import InputText                 from './components/InputText.vue';
import InputUpload               from './components/InputUpload.vue';
import InputPassword             from './components/InputPassword.vue';
import InputDropdown             from './components/InputDropdown.vue';
import InputTextArea             from './components/InputTextArea.vue';
import InputCheckbox             from './components/InputCheckbox.vue';
import InputCheckboxes           from './components/InputCheckboxes.vue';
import InputRadio                from './components/InputRadio.vue';
import InputLabel                from "./components/InputLabel.vue";
import InputCreditCardNumber     from "./components/InputCreditCardNumber.vue";
import InputCreditCardExpiryDate from "./components/InputCreditCardExpiryDate.vue";
import InputCreditCardCCV        from "./components/InputCreditCardCCV.vue";

let props = defineProps( [ "field" ] )
let input = ref( null );


const getData    = () => input.value.getData();
const setError   = ( messages ) => input.value.setError( messages );
const clearError = () => input.value.clearError();
const setValue   = ( value ) => input.value.setValue( value );
const getKey     = () => input.value.key;
const getType    = () => input.value.type;

defineExpose( { getData, setError, clearError, setValue, getKey } )


function importInput ( type )
{
    let objPath = {
        "text"                    : InputText,
        "password"                : InputPassword,
        "upload"                  : InputUpload,
        "dropdown"                : InputDropdown,
        "textarea"                : InputTextArea,
        "checkbox"                : InputCheckbox,
        "checkboxes"              : InputCheckboxes,
        "radios"                  : InputRadio,
        "label"                   : InputLabel,
        "credit-card-number"      : InputCreditCardNumber,
        "credit-card-expiry-date" : InputCreditCardExpiryDate,
        "credit-card-ccv"         : InputCreditCardCCV,
    }

    return objPath[ type ] ?? InputText;
}


</script>
